import MultiLanguageMap from "./MultiLanguageMap";

export class Language {
  public languageCode: string;
  public languageName: MultiLanguageMap = new MultiLanguageMap();

  constructor(obj: any) {
    this.languageCode = obj.languageCode;
    this.languageName.readObject(obj, "languageName");
  }
}
